import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "p-6"
};
const _hoisted_4 = {
  class: "mb-4"
};
const _hoisted_5 = {
  class: "text-lg font-semibold text-slate-800"
};
const _hoisted_6 = {
  class: "text-sm text-slate-500 mt-1"
};
const _hoisted_7 = {
  key: 0,
  class: "prose prose-sm max-w-none"
};
const _hoisted_8 = {
  key: 1,
  class: "text-sm leading-6 text-slate-600 whitespace-pre-wrap"
};
const _hoisted_9 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
import { computed } from 'vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'MessageDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: null
    },
    showNavigation: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '消息详情'
    }
  },
  emits: ['update:modelValue', 'navigate'],
  setup(__props) {
    const props = __props;
    const currentMessage = computed(() => props.message);
    return (_ctx, _cache) => {
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createBlock(AppModal, {
        visible: __props.modelValue,
        size: "2xl",
        onClose: _cache[3] || (_cache[3] = $event => _ctx.$emit('update:modelValue', false))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1), _createElementVNode("button", {
          type: "button",
          class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
          "aria-label": "关闭",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', false))
        }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h4", _hoisted_5, _toDisplayString(currentMessage.value?.title || '消息通知'), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(currentMessage.value?.time), 1)]), currentMessage.value?.contentHtml ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, null, 512)), [[_directive_safe_html, currentMessage.value.contentHtml]]) : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(currentMessage.value?.content || '暂无内容'), 1))]), _createElementVNode("div", _hoisted_9, [currentMessage.value && __props.showNavigation ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "px-4 py-2 bg-primary-700 text-white rounded-lg text-sm hover:bg-primary-800 transition-colors",
          onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('navigate', __props.message))
        }, " 查看 ")) : _createCommentVNode("", true), _createElementVNode("button", {
          type: "button",
          class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-50 transition-colors",
          onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('update:modelValue', false))
        }, " 关闭 ")])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};